import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { UserContextSelectors } from '@app/shared/state/user-context/user-context.selectors';

export const assemblerGuardFn: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);
  const store = inject(Store);

  const isAssembler = store.selectSignal(UserContextSelectors.isAssembler)

  const isNavigatingToStart = state.url.includes('/start')

  return isAssembler() && isNavigatingToStart
    ? router.createUrlTree(['/workOrders'])
    : true;
};
